const sassVars = require("!!sass-variables-loader!../styles/variables.scss") // import the variables from scss

const breakpoints = {
  sm: parseInt(sassVars.MQ_SMALL, 10),
  md: parseInt(sassVars.MQ_MEDIUM, 10),
  lg: parseInt(sassVars.MQ_LARGE, 10),
  xl: parseInt(sassVars.MQ_XLARGE, 10),
  xxl: parseInt(sassVars.MQ_XXLARGE, 10),
  huge: parseInt(sassVars.MQ_HUGE, 10),
}

const constants = {
  START_APP: "START_APP",

  PIXI_STAGE_READY: "PIXI_STAGE_READY",

  UPDATE_STORY: "UPDATE_STORY",

  ROUTE_UPDATED: "ROUTE_UPDATED",

  COLOUR: "COLOUR",
  SCIENCE: "SCIENCE",

  SET_LANGUAGE: "SET_LANGUAGE",
  SET_VERSION: "SET_VERSION",

  ADD_CHILD: "ADD_CHILD",
  REMOVE_CHILD: "REMOVE_CHILD",

  LAUNCH_VIDEO: "LAUNCH_VIDEO",
  CLOSE_VIDEO: "CLOSE_VIDEO",

  OPEN_MENU: "OPEN_MENU",
  CLOSE_MENU: "CLOSE_MENU",

  CHANGE_SLIDE: "CHANGE_SLIDE",

  OPEN_LOOKBOOK: "OPEN_LOOKBOOK",
  CLOSE_LOOKBOOK: "CLOSE_LOOKBOOK",

  MOBILE: "mobile",
  DESKTOP: "desktop",

  DEVELOPMENT: "development",
  STAGING: "staging",
  PRODUCTION: "production",

  breakpoints,

  slugify: (text) => {
    return text.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  },

  // Font Sizes
  h1: `font-sans text-4xl md:text-5xl lg:text-7xl `,
  h2: `font-sans text-3xl lg:text-3xl`,
  h3: `font-sans text-2xl lg:text-xl`,
  h4: `font-sans text-4xl `,
  quote: `font-body text-xl md:text-2xl lg:text-3xl`,
  paragraph: `font-body text-sm md:text-base lg:text-xl`,
  paragraph2: `font-sans text-sm md:text-lg`,
  caption: `font-sans text-sm md:text-base`,
  heading: `font-sans text-lg lg:text-2xl`,
  attribution: `font-sans text-sm md:text-base`,
  button: `font-body text-base md:text-xl `,

  // Overall padding/margin
  pad: `8`,
  padmob: `6`,

  BASE_URL: process.env.GATSBY_ENV === "development" ? `${ typeof window !== `undefined` && window.location ? window.location.protocol : `http:` }//localhost:8024/` : process.env.GATSBY_ENV === "production" ? `https://hminnovationstories.com/` : `https://hm-innovation-staging.netlify.app/`,
}

export default constants